<!--
2024-07-10 YTW 邀请排行榜
-->
<template>
  <div class="main-content" id="main-content">
    <div class="relative">
      <TopBack style="position: relative" :title="$t('lang.SharingStar.title')"/>
      <div class="banner">
        <img
          src="https://betapp-images.s3.ap-northeast-1.amazonaws.com/Homebanner/fumqkcnm0ud4jjuzcm4zt8h2ih45znvpPGE_share_banner.png"
          alt=""/>
      </div>
      <div class="rankTable">
        <div class="caption" :style="$store.state.locale==='IN'?'font-size:3.2vw':''">
          <div>{{ $t('lang.SharingStar.Rank') }}</div>
          <div>{{ $t('lang.SharingStar.Name') }}</div>
          <div>{{ $t('lang.SharingStar.ValidInvitees') }}</div>
          <div>{{ $t('lang.SharingStar.Rewards') }}</div>
        </div>
        <div class="tbody" ref="tbody" @scroll="handleScroll">
          <div class="tr" v-for="(rank,index) in ranks" :key="index">
            <div class="td">{{ rank.Rank }}</div>
            <div class="td">{{ rank.UserName }}</div>
            <div class="td">{{ rank.ValidInvitees }}</div>
            <div class="td">{{ rank.Rewards }}</div>
          </div>
        </div>
        <div class="topShadow" v-show="!isTop"/>
        <div class="bottomShadow" v-show="isTop"/>
        <div class="myRank">
          <div class="tr">
            <div class="td">{{ myRank.Rank }}</div>
            <div class="td">{{ isLogin ? $t('lang.SharingStar.me') : '-' }}</div>
            <div class="td">{{ myRank.ValidInvitees }}</div>
            <div class="td">{{ myRank.Rewards }}</div>
          </div>
        </div>
      </div>
      <div class="button" :style="buttonStatus===false&&isLogin?'filter: grayscale(100%)':''"
           @click="claimReward">
        {{ $t('lang.SharingStar.Claim') }}
      </div>
      <div class="showNow">
        <div class="inline">
          <div class="left">{{ $t('lang.SharingStar.shareNow') }}</div>
        </div>
        <div class="icons">
          <div class="shareIcon" @click="whatsappClick"><img :src="share1" alt=""/></div>
          <div class="shareIcon" @click="telegramClick"><img :src="share2" alt=""/></div>
          <div class="shareIcon" @click="facebookClick"><img :src="share3" alt=""/></div>
          <div class="shareIcon" @click="copyLinkClick"><img :src="share4" alt=""/></div>
        </div>
      </div>
      <div class="channel" @click="outLink">
        <img :src="channel" alt=""/>
        <div class="text"> {{ $t('lang.inviteFriends.channel') }}</div>
      </div>
      <div class="rules">
        <div class="title">{{ $t('lang.promotion.rules') }}</div>
        <div class="content">
          <p v-for="(rule,index) in $t('lang.SharingStar.rules')" :key="index">{{ formatRule(rule, index) }}</p>
        </div>
      </div>
    </div>
    <div class="panel" v-show="modalShow">
      <div class="modal">
        <div class="top">{{ $t('lang.beginnersOnly.congrats') }}</div>
        <div class="message">
          {{ $t('lang.SharingStar.message') }}
        </div>
        <div class="connButtons">
          <div v-for="(tel,index) in tgs" :key="'tg'+index" class="tel">
            <div class="conn" @click="tgConn(tel)">
              <img :src="conn1" alt=""/>
            </div>
            <div class="name">{{ $t('lang.SharingStar.' + tel.Name) }}</div>
          </div>
          <div v-for="(tel,index) in wss" :key="'ws'+index" class="tel">
            <div class="conn" @click="wsConn(tel)">
              <img :src="conn2" alt=""/>
            </div>
            <div class="name">{{ $t('lang.SharingStar.' + tel.Name) }}</div>
          </div>
        </div>
        <div class="buttons">
          <div class="ok" @click="closePanel">{{ $t('lang.common.ok') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopBack from '@/components/TopBack/index'
import share1 from '@/assets/images/SharingStar/icon0.png'
import share2 from '@/assets/images/SharingStar/icon1.png'
import share3 from '@/assets/images/SharingStar/icon2.png'
import share4 from '@/assets/images/SharingStar/icon3.png'
import channel from '@/assets/images/invite/channel.png'
import conn1 from '@/assets/images/SharingStar/conn1.png'
import conn2 from '@/assets/images/SharingStar/conn2.png'
import request from '@/service'
import {Toast} from 'mint-ui'

export default {
  name: 'SharingStar',
  data () {
    return {
      StartDate: '',
      EndDate: '',
      ruleAmount: 1000,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      shareCode: '',
      isTop: true,
      conn1,
      conn2,
      share1,
      share2,
      share3,
      share4,
      channel,
      isLogin: !!localStorage.getItem('userInfo'),
      modalShow: false,
      myRank: {Rank: '-', UserName: '-', ValidInvitees: '-', Rewards: '-'},
      buttonStatus: false,
      servicePhone: null,
      tgs: [],
      wss: [],
      ranks: []
    }
  },
  components: {
    TopBack
  },
  watch: {},
  created () {
  },
  mounted () {
    if (this.userInfo) {
      this.fetchAccount()
    }
    this.fetchRankData()
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    handleScroll (event) {
      const scrollPosition = event.target.scrollTop
      if (scrollPosition < 5) {
        this.isTop = true
      }
      const scrollableDiv = this.$refs.tbody
      const height = scrollableDiv.clientHeight
      const scrollHeight = scrollableDiv.scrollHeight
      // 判断是否滚动到底部
      if (scrollPosition + height + 5 >= scrollHeight) {
        this.isTop = false
      }
    },
    claimReward () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      if (this.buttonStatus) {
        this.modalShow = true
      }
    },
    closePanel () {
      this.modalShow = false
    },
    tgConn (tel) {
      console.log(tel)
      window.open('https://t.me/' + tel.Phone, '_blank')
    },
    wsConn (tel) {
      window.open('http://wa.me/' + tel.Phone, '_blank')
    },
    formatRule (rule, index) {
      if (index === 0) {
        rule = rule.replace('{start}', this.StartDate)
        rule = rule.replace('{end}', this.EndDate)
        return rule
      } else if (index === 1) {
        rule = rule.replace('{ruleAmount}', this.ruleAmount)
        return rule
      } else {
        return rule
      }
    },
    formatDate (originalDateString) {
      // 创建 Date 对象
      const date = new Date(originalDateString)
      // 从 Date 对象获取年、月、日
      const year = date.getFullYear()
      // 注意，月份从 0 开始，所以要加 1
      const month = date.getMonth() + 1
      const day = date.getDate()
      // 将月份和日期格式化成两位数
      const formattedMonth = month < 10 ? `0${month}` : `${month}`
      const formattedDay = day < 10 ? `0${day}` : `${day}`
      return `${formattedDay}/${formattedMonth}/${year}`
    },
    msgFormat () {
      let welcomeMessage = this.$t('lang.inviteFriends.inviteMsg')
      let index = this.shareCode.indexOf('/Share')
      if (index === -1) {
        index = this.shareCode.toLowerCase().indexOf('/share')
      }

      welcomeMessage = welcomeMessage.replace('{shareURL}', this.shareCode)
      welcomeMessage = welcomeMessage.replace('{amount1}', this.amount1)
      welcomeMessage = welcomeMessage.replace('{amount2}', this.amount2)
      welcomeMessage = welcomeMessage.replace('{amount3}', this.amount3)
      return welcomeMessage
    },
    telegramClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('Telegram')
      this.copyShares()
      let message = encodeURIComponent(this.msgFormat())
      window.open(`https://t.me/share/url?text=` + message + `&url=%20`)
    },
    whatsappClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('WhatsApp')
      this.copyShares()
      let message = encodeURIComponent(this.msgFormat())
      window.open(`https://wa.me/?text=${message}`, '_blank')
    },
    facebookClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('Facebook')
      this.copyShares()
      window.open(`https://www.facebook.com/sharer.php?u=` + this.shareCode, '_blank')
    },
    copyShares () {
      let message = this.msgFormat()
      let copyBehavior = function (e) {
        e.clipboardData.setData('text/plain', message)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', copyBehavior)
      document.execCommand('copy')
    },
    copyLinkClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.copyShares()
      this.saveUserEvent('Link2')
      Toast(this.$t('lang.inviteFriends.success'))
    },
    saveUserEvent (val) {
      const url = '/innovation/account/save/user/event'
      const data = {EventNameEN: val, UserUniqueId: this.userInfo.UserId}
      request('post', url, data).then(res => {
      }).catch(err => {
        console.log(err)
      })
    },
    fetchLocalAmount () {
      if (this.$store.state.inviteeObj) {
        this.amount1 = this.$store.state.inviteeObj.sevenDayReward
        this.amount2 = this.$store.state.inviteeObj.InviteeReward
        this.amount3 = this.$store.state.inviteeObj.inviteeMaxReward
      } else {
        const url = '/innovation/home/get-system-settings'
        let cid = localStorage.getItem('cid') // （注：从localstorage取出cid）
        const data = {IsApp: 1, CampaignId: cid, userId: this.userInfo ? this.userInfo.UserId : ''}
        request('post', url, data).then(res => {
          this.amount1 = res.SevenDayReward
          this.amount2 = res.InviteeReward
          this.amount3 = res.FirstDepositMaxReward
          this.$store.commit('setInviteeObj',
            {
              sevenDayReward: res.SevenDayReward,
              inviteeMaxReward: res.DefaultCampaignIdFirstDepositMaxReward,
              InviteeReward: res.InviteeReward
            })
        }).catch(err => {
          console.log(err)
        })
      }
    },
    fetchRankData () {
      const url = '/innovation/invite_rank/get_data'
      let data = null
      if (localStorage.getItem('userInfo')) {
        data = {
          userId: this.userInfo.UserId
        }
      } else {
        data = {
          userId: ''
        }
      }
      request('post', url, data).then(res => {
        if (res && res !== -1) {
          if (res.DepositAmount) {
            this.ruleAmount = res.DepositAmount
          }
          this.StartDate = this.formatDate(res.StartDate)
          this.EndDate = this.formatDate(res.EndDate)
          this.ranks = res.TopRank
          this.buttonStatus = res.Button
          if (res.MyRank) {
            this.myRank = res.MyRank
          }
          if (res.ServicePhone && res.ServicePhone.Telegram) {
            this.tgs = res.ServicePhone.Telegram
          }
          if (res.ServicePhone && res.ServicePhone.Telegram) {
            this.wss = res.ServicePhone.Whatsapp
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    fetchAccount () {
      let that = this
      const url = '/innovation/account/getuseraccount'
      const data = {
        userId: this.userInfo.UserId
      }
      request('post', url, data).then(res => {
        that.shareCode = res.InviteLink
        that.fetchLocalAmount()
      }).catch(err => {
        console.log(err)
      })
    },
    outLink () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      window.location.href = 'https://t.me/+y6Swf0yJaNY0NWVl'
    }
  }
}
</script>

<style lang="less" scoped>
.main-content {
  position: fixed;
  padding: 56px 0 70px 0;
  width: 100vw;
  height: 100vh;
  background-color: #000000;
  display: flex;
  overflow-x: hidden;
  overflow-y: auto;

  .panel {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.66);

    .modal {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 83.333vw;
      height: 55.556vw;
      background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #151715 0%, #202020 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
      border: 0.277vw solid #737373;
      border-radius: 4.166vw;

      .top {
        margin-top: 4vw;
        text-align: center;
        font-size: 5.556vw;
        font-weight: 700;
        color: #FFFFFF;
      }

      .message {
        position: relative;
        top: 3vw;
        left: 50%;
        transform: translate(-50%);
        width: 68.672vw;
        height: max-content;
        color: #C4C4C4;
        font-size: 3.888vw;
        font-weight: 400;
        line-height: 5.556vw;
        letter-spacing: 0.02em;
      }

      .connButtons {
        position: relative;
        top: 6.111vw;
        left: 50%;
        transform: translate(-50%);
        display: flex;
        width: 72.542vw;
        height: 17.778vw;
        justify-content: space-between;
        background: #121312;
        border-radius: 2.778vw;

        .tel {
          margin-top: 2.5vw;
          width: 65.2875vw;
          height: max-content;

          .conn {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .name {
          text-align: center;
          color: #FFFFFF;
          margin-top: 1.2vw;
          font-size: 3.055vw;
        }

        img {
          width: 8.611vw;
        }
      }

      .buttons {
        position: relative;
        top: 8vw;
        left: 50%;
        transform: translate(-50%);
        display: flex;
        width: 69.444vw;
        height: 8.333vw;
        justify-content: space-between;
        align-items: flex-start;

        .ok {
          margin-top: 0.5vw;
          width: 100%;
          text-align: center;
        }
      }
    }
  }

  .relative {
    position: relative;
    width: 100%;
    height: max-content;
    z-index: 0;
  }

  .banner {
    position: relative;
    top: 2.5vw;
    left: 50%;
    transform: translate(-50%);
    width: 89.936vw;
    height: 34.688vw;

    img {
      width: 100%;
    }
  }

  .rankTable {
    position: relative;
    top: 5vw;
    left: 50%;
    transform: translate(-50%);
    width: 89.404vw;
    text-align: center;
    border-spacing: 0;
    border-collapse: separate;
    background: linear-gradient(180deg, #181818 0%, #1D1D1D 100%);
    border-radius: 2.222vw;

    .caption {
      margin: auto;
      width: 81.077vw;
      height: 10.486vw;
      line-height: 10.486vw;
      color: #575757;
      font-size: 3.612vw;
      font-weight: 600;
      display: flex;
      justify-content: space-between;
      white-space: nowrap;

      div {
        width: 20.26925vw;
      }
    }

    .caption div:first-child {
      width: 12vw;
    }

    .caption div:nth-child(3) {
      width: 23vw;
      text-align: right;
    }

    .tbody {
      position: relative;
      top: 0;
      left: 50%;
      transform: translate(-50%);
      overflow-x: hidden;
      overflow-y: auto;
      width: 89.404vw;
      height: 82.5vw;
      padding: 0 4.166vw 12.847vw 4.166vw;

      .tr {
        width: 81.077vw;
        height: 7.5vw;
        background: #2C2C2C;
        border-radius: 1.388vw;
        border: none;
        display: flex;
        justify-content: space-between;
        margin-top: 2.222vw;
      }

      .td {
        width: 20.26925vw;
        font-family: Inter;
        font-size: 3.612vw;
        font-weight: 700;
        color: #FFFFFF;
        line-height: 7.5vw;
        border: none;
        padding: 0;
      }

      .tr .td:first-child {
        width: 12vw;
      }
    }

    .topShadow {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      top: 5.3vw;
      width: 89.404vw;
      height: 5vw;
      box-shadow: 0 5vw 5vw 0 rgba(0, 0, 0, 0.7);
    }

    .bottomShadow {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      bottom: 7.2vw;
      width: 89.404vw;
      height: 5vw;
      box-shadow: 0 -5vw 5vw 0 rgba(0, 0, 0, 0.7);
    }

    .myRank {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      bottom: -0.5vw;
      width: 89.404vw;
      height: 12.9vw;
      background: #1D1D1D;
      border-top: 1.5px #111111 solid;
      border-bottom-left-radius: 2.222vw;
      border-bottom-right-radius: 2.222vw;

      .tr {
        margin: 2.222vw auto 0 auto;
        width: 81.077vw;
        height: 7.5vw;
        background: #2C2C2C;
        border-radius: 1.388vw;
        border: none;
        display: flex;
        justify-content: space-between;

        .td {
          width: 20.26925vw;
          font-family: Inter;
          font-size: 3.612vw;
          font-weight: 700;
          color: #FFFFFF;
          line-height: 7.5vw;
          border: none;
          padding: 0;
        }
      }

      .tr .td:first-child {
        width: 12vw;
      }
    }
  }

  .button {
    position: relative;
    top: 10vw;
    left: 50%;
    transform: translate(-50%);
    width: 74.444vw;
    height: 10.3vw;
    line-height: 10.3vw;
    text-align: center;
    background: linear-gradient(270.12deg, #DEBC86 -2.41%, #F7DEB8 113.36%);
    border-radius: 0.8333vw;
    font-family: Inter;
    font-size: 5.277vw;
    font-weight: 600;
    color: #000000;
  }

  .showNow {
    position: relative;
    top: 13.5vw;
    left: 50%;
    transform: translate(-50%);
    width: 88.888vw;
    height: 37.5vw;

    .inline {
      position: relative;
      top: 0;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      height: 6.388vw;
      text-transform: capitalize;

      .left {
        font-family: Inter;
        font-size: 5.277vw;
        line-height: 5.277vw;
        font-weight: 800;
        text-align: left;
        color: #FFFFFF;
      }
    }

    .icons {
      position: relative;
      top: 3.5vw;
      left: 50%;
      transform: translate(-50%);
      width: 89.166vw;
      height: 24.444vw;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: radial-gradient(50% 50% at 50% 50%, #272727 0%, #202020 100%);
      padding: 0 2.778vw;
      border-radius: 2.222vw;

      .shareIcon {
        width: auto;
        height: 18.055vw;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .channel {
    position: relative;
    top: 14vw;
    left: 50%;
    transform: translate(-50%);
    width: 89.366vw;

    img {
      width: 100%;
    }

    .text {
      position: absolute;
      top: 0;
      line-height: 15.371vw;
      left: 16vw;
      font-weight: 700;
      font-size: 5.112vw;
      text-align: center;
      color: #FFFFFF;
    }
  }

  .rules {
    position: relative;
    top: 18vw;
    left: 50%;
    transform: translate(-50%);
    width: 90.555vw;
    height: max-content;
    margin-bottom: 20vw;

    .title {
      font-family: Inter;
      font-size: 5.277vw;
      font-weight: 700;
      line-height: 6.388vw;
      text-align: left;
      color: #FFFFFF;
      margin-bottom: 2vw;
    }

    .content {
      padding: 2vw 0 0 1.111vw;
      font-family: Inter;
      font-size: 4.166vw;
      font-weight: 500;
      line-height: 6.111vw;
      text-align: left;
      color: #C5C5C5;
      height: max-content;

      p {
        margin-bottom: 1vw;
      }
    }
  }
}

.main-content::-webkit-scrollbar {
  display: none
}

.tbody::-webkit-scrollbar {
  display: none
}

</style>



// WEBPACK FOOTER //
// src/pages/SharingStar/index.vue